import models from './models'
import util from '../../../util'

export default {
    initialize({ commit, state, dispatch }, payload) {
        if (payload.hasOwnProperty('theme')) {
            commit('SET_THEME', payload.theme)
        }
        if (payload.hasOwnProperty('session')) {
            commit('SET_SESSION', payload.session)
        }
        if (payload.complete == true) {
            commit('SET_COMPLETE')
        }

        commit('SET_ID', payload.id)
        commit('SET_CODE', payload.code)
        commit('SET_TYPE', payload.type)
        commit('SET_PREVIEW', payload.preview)
        commit('SET_SIGNUP', payload.signup)
        commit('SET_INIT_AUTH', payload.init_auth)
        commit('SET_SECURITY', payload.template.security)
        commit('SET_TEMPLATE', payload.template)
        commit('SET_INFO', { company: payload.company, user: payload.author })
        commit('SET_MACROS', payload.macros)
        commit('SET_CREATED', payload.created)
        commit('ADD_MEMBER', { ...{ type: 'CLIENT', active: true, coclient: false }, ...payload.member })
        commit('SET_PAGE', payload.template.panels[0])
        commit('auth/SET_METHOD', payload.auth)

        if (payload.hasOwnProperty('otp')) {
            commit('SET_OTP', payload.otp)
            let url = new URL(window.location.href);
            url.searchParams.delete('otp');

            window.history.pushState({}, document.title, url);
        }

        if (payload.hasOwnProperty('download') && state.security == 'HIGH' && state.complete == true) {
            commit('SET_DOWNLOAD', payload.download)
            let member = state.members.find(m => m.active == true)
            if (member.security == 'LOW' && member.phone && member.phone.number && member.phone.code) {
                commit('auth/SET_ACTIVE', 'phone')
            }
            if (member.security == 'LOW' && (!member.phone || !member.phone.number || !member.phone.code)) {
                commit('auth/SET_ACTIVE', 'pin')
            }
            if (member.security == 'HIGH') {
                commit('auth/SET_ACTIVE', 'signin')
            }
        }
    },
    create({ commit, state }) {
        if (state.request != null) {
            return;
        }
        commit('SET_LOADING', true)
        commit('SET_REQUEST', axios.CancelToken.source())
        return axios.post('/w/create', { id: state.id, code: state.code }).then(response => {
            commit('auth/SET_AUTHENTICATED', true)
            commit('SET_ID', response.data.id)
            let member = state.members.find(m => m.active == true)
            if (member && member.name && member.security == 'LOW') {
                commit('SET_MEMBERS', response.data.members)
                commit('SET_PANELS', response.data.panels)
                commit('SET_GROUPS', response.data.groups)
                commit('SET_ELEMENTS', response.data.elements)
                commit('SET_SIGNATURES', response.data.signatures)
                commit('SET_DYNAMIC', response.data.dynamic)
            } else {
                commit('REFRESH_DATA', response.data)
            }
            if (response.data.hasOwnProperty('session')) {
                commit('SET_SESSION', response.data.session)
            }
            if (response.data.hasOwnProperty('macros')) {
                commit('SET_MACROS', response.data.macros)
            }
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
            return true
        }).catch(error => {
            let message = parseError(error)
            return false
        })
    },
    open({ commit, state }) {
        commit('SET_LOADING', true)
        commit('SET_REQUEST', axios.CancelToken.source())
        let member = state.members.find(m => m.active == true)
        let payload = { id: state.id, code: member.code, download: state.download }
        let route = state.preview == true ? '/app/engagement/open' : '/e/open'
        if (state.type == 'web-engagement') {
            route = '/w/open';
            payload.code = state.code
        }
        return axios.post(route, payload).then(response => {
            if (state.type == 'web-engagement') {
                commit('SET_ID', response.data.id)
                if (response.data.hasOwnProperty('session')) {
                    commit('SET_SESSION', response.data.session)
                }
                if (response.data.hasOwnProperty('macros')) {
                    commit('SET_MACROS', response.data.macros)
                }
            }
            commit('SET_MEMBERS', response.data.members)
            commit('SET_PANELS', response.data.panels)
            commit('SET_GROUPS', response.data.groups)
            commit('SET_ELEMENTS', response.data.elements)
            commit('SET_SIGNATURES', response.data.signatures)
            commit('SET_PDFS', response.data.pdfs)
            commit('SET_DYNAMIC', response.data.dynamic)
            commit('auth/SET_AUTHENTICATED', true)
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
            if (state.security != 'LOW') {
                commit('SET_TIMEOUT')
            }
            return true
        }).catch(error => {
            let message = parseError(error)
            return false
        })
    },
    save({ commit, state, getters }) {
        if (state.request != null) {
            state.request.cancel('Request Canceled.')
        }
        if (state.complete || state.queue.length == 0) {
            return;
        }
        let elements = []
        let hasUploads = false
        let queue = []
        let cQueue = state.queue.filter(e => e._default !== true)
        cQueue.forEach((e) => {
            queue.push(e)
            queue = queue.concat(state.queue.filter(d => d._default === true && d.group == e.group))
        })
        if (queue.length == 0) {
            return;
        }
        commit('SET_LOADING', true)
        commit('SET_REQUEST', axios.CancelToken.source())
        queue.forEach((e) => {
            let element = util.get(state.elements.find(el => el.id == e.id))
            if (element) {
                if (e.upload && e.upload == true) {
                    hasUploads = true
                    element.action = e.remove && e.remove == true ? 'remove' : 'upload'
                    element.value = e.value
                } else {
                    element.action = e.remove && e.remove == true ? 'remove' : 'store'
                    element.value = e.value
                }
                element._key = e._key
                elements.push(element)
            }
        })

        let member = state.members.find(m => m.active == true)
        let payload = hasUploads ? util.toFormData({
            id: state.id,
            elements: elements,
            code: member.code
        }) : { id: state.id, elements: elements, code: member.code }
        let route = state.preview == true ? '/app/engagement/save' : '/e/save'

        return axios.post(route, payload, { cancelToken: state.request.token }).then(response => {
            elements.forEach((e) => {
                e.invalid = response.data.saved.indexOf(e.id) === -1
                if (e.invalid == false) {
                    e.valid = true
                    e.exists = true
                }
                if (e.action == 'upload' && response.data.uploaded) {
                    let uploaded = response.data.uploaded.find(u => u.id == e.id)
                    if (uploaded && uploaded.value) {
                        e.value = uploaded.value
                    }
                }
                if (e.action == 'remove') {
                    commit('REMOVE_ELEMENT', e)
                    if (state.elements.filter(el => el.group == e.group).length == 0) {
                        commit('REMOVE_GROUP', { id: e.group })
                    }
                } else {
                    commit('ADD_ELEMENT', e)
                    commit('ADD_DYNAMIC', e)
                }
                if (getters.identification && e.valid && e.definition && e.value) {
                    let field = getters.dataIdentification(e.definition)
                    if (field) {
                        let panel = state.panels.find(p => p.id == e.panel)
                        let type = panel && panel.type == 'COCLIENT' ? 'COCLIENT' : 'CLIENT'
                        let member = state.members.find(m => m.type == type)
                        if (member && field == 'first_name') {
                            member.first_name = e.value
                            let lname = member.last_name ? member.last_name : ''
                            member.name = e.value + ' ' + lname
                        } else if (member && field == 'last_name') {
                            member.last_name = e.value
                            let fname = member.first_name ? member.first_name : ''
                            member.name = fname + ' ' + e.value
                        } else {
                            member[field] = e.value
                        }
                        commit('ADD_MEMBER', member)
                    }
                }
                commit('UNQUEUE', { _key: e._key })
                commit('SET_CALCULATED', response.data.calculated)
                response.data.calculated.forEach(e => {
                    commit('ADD_DYNAMIC', e)
                })
            })
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
            commit('SET_TIMEOUT')
            return true
        }).catch(error => {
            if (!axios.isCancel(error)) {
                let message = parseError(error)
            }
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
            return axios.isCancel(error) ? null : false
        })
    },
    signature({ commit, state }, payload) {
        commit('SET_LOADING', true)
        let member = state.members.find(m => m.active == true)
        let route = state.preview == true ? '/app/engagement/signature' : '/e/signature'
        return axios.post(route, {
            id: state.id,
            code: member.code,
            signature: models.signature(payload)
        }).then(response => {
            commit('ADD_SIGNATURE', response.data)
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
            commit('SET_TIMEOUT')
            return response
        }).catch(error => {
            let message = parseError(error)
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
        })
    },
    unlock({ commit, state }, payload) {
        commit('SET_LOADING', true)
        return axios.post('/app/engagement/unlock', payload).then(response => {
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
            commit('SET_TIMEOUT')
            return { value: response.data.value, error: false }
        }).catch(error => {
            let message = parseError(error)
            message = message && message.message ? message.message : message
            commit('SET_REQUEST', null)
            commit('SET_LOADING', false)
            return { value: message, error: true }
        })
    },
    close({ commit, state, dispatch }) {
        return dispatch('save').then(response => {
            commit('SET_LOADING', true)
            let member = state.members.find(m => m.active == true)
            return axios.post('/e/close', { id: state.id, code: member.code }).then(response => {
                if (response.data && response.data.documents) {
                    response.data.documents.forEach(s => commit('ADD_SIGNATURE', s))
                }
                if (response.data && response.data.pdfs) {
                    commit('SET_PDFS', response.data.pdfs)
                }
                if (response.data && response.data.pending) {
                    commit('SET_SIGNATURE_PENDING', response.data.pending)
                }
                commit('SET_PAGE', state.template.panels.slice(-1)[0])
                commit('SET_LOADING', false)
                commit('SET_COMPLETE')
                commit('SET_TIMEOUT')
                return true
            }).catch(error => {
                let message = parseError(error)
                return false
            })
        })
    },
    analytics({ commit, state }, payload) {
        if (payload.action == 'enter') {
            commit('SET_ANALYTICS_ENTER', payload.id)
        }
        if (payload.action == 'leave') {
            commit('SET_ANALYTICS_LEAVE', payload.id)
        }
        if (payload.action == 'unload') {
            commit('SET_ANALYTICS_LEAVE', payload.id)
        }
        if ((payload.action == 'unload' || payload.action == 'complete') && state.analytics.panels.length > 0) {
            axios.post('/e/analytics', {
                id: state.id,
                total: state.analytics.total,
                panels: state.analytics.panels
            }).then(response => {
                commit('RESET_ANALYTICS')
            })
        }
    },
}
